interface AnalyzeReport {
  key: string
  title: string
  text: string
  icon?: string
}

export const ANALYZE_REPORT: AnalyzeReport[] = [
  {
    key: "print",
    title: "ペーパーレスオペレーション",
    text: "印刷に関わる業務を抽出・分析し、データを表示します。",
    icon: "/static/images/analyze/paperless.png",
  },
  {
    key: "work_style",
    title: "ワークスタイル",
    text: "リモートワークを抽出・分析し、オフィスワークとの比較データを表示します。",
    icon: "/static/images/analyze/remote.png",
  },
  {
    key: "application",
    title: "ITガバナンス - アプリケーション",
    text: "使用しているアプリケーションを抽出し、一覧データを表示します。",
    icon: "/static/images/analyze/application.png",
  },
  {
    key: "member_application",
    title: "ITガバナンス - ユーザー",
    text: "使用しているアプリケーションをメンバー別に抽出し、一覧データを表示します。",
    icon: "/static/images/analyze/application_member.png",
  },
]

export default ANALYZE_REPORT
